<template lang="pug">
    div
        v-card.mb-5(outlined)
            v-card-title Загрузка .xls файла
            v-card-text
                v-form(v-on:submit.prevent="onSubmit")
                    v-file-input(v-model="file" name="file" accept=".xls" placeholder=".xls файл" dense outlined :loading="loading")

                    v-card-actions
                        v-btn(type="submit") Загрузить 
                        v-spacer
                        v-btn(color="error" @click="showDeleteAll") Удалить всё

        v-card(outlined)
            v-card-actions
                v-btn(@click="showAddDictres()") Добавить

            v-data-table(:headers="headers" :items="dictantresults" :loading="tableloading" locale="ru-RU")
                template(v-slot:item.actions="{ item }")
                    v-icon(small class="mr-2" @click="showEditDictres(item)") mdi-pencil
                    v-icon(small @click="showDeleteDictres(item)") mdi-delete

        
        v-dialog(v-model="drDialog" max-width="900" scrollable)
            v-card(v-if="editDictRes")
                v-card-title
                    span(v-if="mode == 'add'") Добавить
                    span(v-else-if="mode == 'edit'") Редактировать
                    span(v-else-if="mode == 'del'") Удалить
                    v-spacer
                    v-btn.ml-1(outlined icon small @click="closeDialog()")
                         v-icon.mr-0 mdi-close

                v-card-text
                    v-form(v-if="mode == 'add' || mode == 'edit'" v-on:submit.prevent="onSubmitDictres")
                        v-text-field(outlined v-model="editDictRes.fname" label="Фамилия" required :error-messages="fnameErrors" @input="$v.editDictRes.fname.$touch()" @blur="$v.editDictRes.fname.$touch()")
                        v-text-field(outlined v-model="editDictRes.mname" label="Имя")
                        v-text-field(outlined v-model="editDictRes.lname" label="Отчество")
                        v-text-field(outlined v-model="editDictRes.city" label="Населённый пункт")
                        v-text-field(outlined v-model="editDictRes.ball" label="Балл" type="number" required :error-messages="ballErrors" @input="$v.editDictRes.ball.$touch()" @blur="$v.editDictRes.ball.$touch()")

                        v-card-actions
                                v-btn(type="submit") Сохранить
                    
                    div(v-if="mode == 'del'") Удалить результат?
                        v-card-actions
                            v-btn(@click="deleteDictres()") Удалить
                                v-icon(small) mdi-delete

        v-dialog(v-model="delAllDialog" max-width="400" scrollable)
            v-card
                v-card-title Удалить все результаты
                v-card-text Вы уверены что хотите удалить все результаты?
                v-card-actions
                    v-btn(@click="delAllDialog = !delAllDialog") Нет
                    v-btn(@click="deleteAll") Да

                        
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import { required, integer } from 'vuelidate/lib/validators'

    import { dictresultService } from '@/_services'

    export default {
        mixins: [validationMixin],
        validations: {
            editDictRes: {
                fname: { required },
                ball: { required, integer }
            }
        },
        mounted () {
            this.loadList()
        },
        computed: {
            fnameErrors () {
                const errors = []
                if (!this.$v.editDictRes.fname.$dirty) return errors
                !this.$v.editDictRes.fname.required && errors.push('Обязательное поле')
                return errors
            },
            ballErrors () {
                const errors = []
                if (!this.$v.editDictRes.ball.$dirty) return errors
                var re = /^[0-9]+$/gi
                if (!re.test(this.editDictRes.ball)) errors.push('Целое число')
                !this.$v.editDictRes.ball.required && errors.push('Обязательное поле')
                return errors
            }
        },
        methods: {
            loadList(){
                this.tableloading = true
                dictresultService.loadList().then(data => {
                    this.dictantresults = data
                    this.tableloading = false
                })
            },
            onSubmit(e){
                if (this.file != null){
                    var data = new FormData(e.target)
                    this.loading = true
                    dictresultService.parseFile(data).then(data =>{
                        this.loading = false
                        this.file = null
                        this.loadList()
                    })
                }
            },
            showAddDictres(){
                this.mode = 'add'
                this.drDialog = true
                this.editDictRes = {fname:'', lname:'', mname:'', city:'', ball:''}
            },
            showEditDictres(item){
                this.mode = 'edit'
                this.drDialog = true
                this.editDictRes = item
            },
            showDeleteDictres(item){
                this.mode = 'del'
                this.drDialog = true
                this.editDictRes = item
            },
            closeDialog(){
                this.mode = null
                this.drDialog = false
                this.editDictRes = null
            },
            validate(){
                this.$v.$touch()
                let isInvalid = this.$v.$invalid
                return isInvalid
            },
            onSubmitDictres(){
                if (!this.validate()) {
                    this.$nextTick(() => {
                        dictresultService.save(this.editDictRes).then(data => {
                            if (this.mode == 'add'){
                                this.dictantresults.push(data)
                            } else {
                                this.dictantresults.map(e => {e.id === data.id ? data : e})
                            }
                            this.mode = null
                            this.drDialog = false
                            this.editDictRes = null
                        })
                    })
                }
            },
            deleteDictres(){
                dictresultService.del(this.editDictRes.id).then(data => {
                    let ind = this.dictantresults.findIndex(e => e.id == this.editDictRes.id)
                    this.dictantresults.splice(ind,1)
                    this.mode = null
                    this.drDialog = false
                    this.editDictRes = null
                })
            },
            showDeleteAll(){
                this.delAllDialog = true
            },
            deleteAll(){
                dictresultService.delAll().then(data => {
                    this.loadList()
                })
            }
        },

        data () {
            return {
                file:null,
                loading:false,
                tableloading:false,
                headers: [
                    {text: 'id', value: 'id'},
                    {text: 'Фамилия', value: 'fname'},
                    {text: 'Имя', value: 'mname'},
                    {text: 'Отчество', value: 'lname'},
                    {text: 'Город', value: 'city'},
                    {text: 'Балл', value: 'ball'},
                    {text: 'Действия', value: 'actions', sortable: false }
                ],
                dictantresults:[],

                drDialog:false,
                mode:null,
                editDictRes:null,
                delAllDialog:false
            }
        }
    }
</script>